<tec-modal
    [isVisible]="true"
    [title]="'COMPANIES.DETAIL.TITLE' | translate"
    [tagImage]="{ icon: 'icon-briefcase' }"
    [buttonSecondaryLabel]="editButtonLabel"
    (closeEvent)="onModalClose($event)"
>
    <ng-container body>
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }

        @if (detail) {
            <tec-item
                [title]="detail.name"
                size="lg"
                [detailAction]="createdAtLabel"
            >
                <tec-tag [status]="detail.enabled ? 'success' : 'disabled'">
                    {{ (detail.enabled ? 'COMPANIES.ACTIVE' : 'COMPANIES.INACTIVE') | translate }}
                </tec-tag>
                @if (detail.code) {
                    <tec-info-group>
                        <b>{{ 'COMPANIES.LIST.CODE_LABEL' | translate }}</b>
                        <span>{{ detail.code | uppercase }}</span>
                    </tec-info-group>
                }
                @if (menuOptions.length > 0) {
                    <tec-menu [options]="menuOptions" (valueChange)="onMenuChange($event)">
                        <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
                    </tec-menu>
                }
            </tec-item>

            <tec-tile styling="thin">
                <div class="item-group">
                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.MANUAL_VALIDATION' | translate"
                        [tagImage]="{ icon: 'icon-check-circle' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.MANUAL_VALIDATION_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-switch [value]="!!detail.manual_validation" [disabled]="true" />
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.DOCUMENT_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-file' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-input [value]="formatRetention(detail.document_retention_days)" [disabled]="true" />
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.MEDIA_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-image' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-input [value]="formatRetention(detail.media_retention_days)" [disabled]="true" />
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.INFO_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-text' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-input [value]="formatRetention(detail.info_retention_days)" [disabled]="true" />
                    </tec-item>
                </div>
            </tec-tile>
        }
    </ng-container>
</tec-modal>
